import { format, formatDistanceToNow, parseISO } from "date-fns";

export function inr(v, { decimals } = {}) {
  const n = Number(v || 0);
  const frac = decimals ?? (Math.round(n * 100) % 100 !== 0 ? 2 : 0);
  return new Intl.NumberFormat("en-IN", {
    style: "currency", currency: "INR", minimumFractionDigits: frac, maximumFractionDigits: frac,
  }).format(n);
}

export const num = (v) => Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 4 });
export const pct = (v) => `${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}%`;

export function fdate(s) {
  if (!s) return "";
  try { return format(parseISO(s), "d MMM yyyy"); } catch { return s; }
}

export function ago(iso) {
  if (!iso) return "";
  try { return formatDistanceToNow(parseISO(iso), { addSuffix: true }); } catch { return iso; }
}

export const initials = (n = "") => n.split(" ").filter(Boolean).slice(0, 2).map((x) => x[0]).join("").toUpperCase();
export const firstName = (n = "") => n.split(" ")[0];
export const today = () => format(new Date(), "yyyy-MM-dd");

// integer helpers to avoid float drift in previews (server is the source of truth)
export const toUnits = (s, scale) => Math.round(Number(s || 0) * scale);
export const fromUnits = (u, scale, dp) => (u / scale).toFixed(dp);

export const CATEGORY_LABEL = { stock: "Stocks", commodity: "Commodities", business: "Business Partnerships" };
export const STATUS_LABEL = {
  pending: "Pending confirmation", edit_requested: "Edit requested", confirmed: "Confirmed",
  rejected: "Rejected", active: "Active", closed: "Closed", inactive: "Inactive",
};
